import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "middle-page-topthird"
};
const _hoisted_2 = {
    key: 1,
    class: "mt-5"
};
const _hoisted_3 = { key: 0 };
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerLoadWait',
    props: {
        isSpinner: { type: Boolean, default: true },
        customer: {},
        cardBlocks: { type: Boolean, default: false },
        withTopCard: { type: Boolean, default: true }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!_ctx.customer && _ctx.isSpinner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
                        _createElementVNode("span", { class: "loader" }, null, -1)
                    ])))
                    : _createCommentVNode("", true),
                (!_ctx.customer && !_ctx.isSpinner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_ctx.cardBlocks)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_ctx.withTopCard)
                                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        class: "mx-auto",
                                                        width: "100%",
                                                        type: "card"
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    class: "mx-auto",
                                                    width: "100%",
                                                    type: "paragraph"
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    class: "mx-auto",
                                                    width: "100%",
                                                    type: "card"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    class: "mx-auto",
                                                    width: "100%",
                                                    type: "card"
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    class: "mx-auto",
                                                    width: "100%",
                                                    type: "card"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    class: "mx-auto",
                                                    width: "100%",
                                                    type: "card"
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true),
                        (!_ctx.cardBlocks)
                            ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                key: 1,
                                class: "mx-auto",
                                width: "100%",
                                type: "card, article, article, article, article"
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
